import React, { useState, useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { PrimaryIconButton, SecondaryIconButton } from '../../theme/index';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { modalAction, modalDeleteAction } from '../../redux/reducers/Modal';
import SuccessModal from '../SuccessModal';
import DangerModal from '../DangerModal';
import { Pagination, PaginationItem, Grid } from '@mui/material';
import styled from '@mui/material/styles/styled';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const PaginationGrid = styled(Grid)(({ theme }) => `
    ul{
        justify-content: end
    }

    button:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)

const PaginationItemStyled = styled(PaginationItem)(({ theme }) => `
    svg{
        color: #000;
    }

    button:hover, svg:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)


function createData(code, name, brand, details, buyPrice, sellPrice, status) {
    return { code, name, brand, details, buyPrice, sellPrice, status };
  }

  const rows = [
    createData('001', 'Gaseosa', 'Coca-Cola', '(1 Litro)', 2, 3.5, true),
    createData('002', 'Galleta', 'Festival', '(350g)', 1, 2, true),
    createData('003', 'Cigarrillos', 'Marlboro', '(1 paquete)', 2, 4, true),
    createData('004', 'Cigarrillos', 'Chesterfield', '(1 paquete)', 2.5, 4, true),
    createData('005', 'Cerveza', 'Corona', '(1 unidad)', 1, 2, true),
    createData('006', 'Cartas de juego', 'Fournier', '(1 paquete)', 3, 5, true),
    createData('007', 'Velas de olor', 'Rituals ', '(3 unidades)', 1, 2, true),
    createData('008', 'Gafas de sol', 'Ray-Ban', '(1 unidad)', 4, 6, true),
    createData('009', 'Pizza', 'Coca-Cola', 'pequeña', 6, 8, true),
    createData('010', 'Pizza mediana', 'A la leña', 'mediana', 7, 12, true),
    createData('011', 'Pizza grande', 'A la leña', 'grande', 10, 16, true),
    createData('012', 'Jabón ', 'Johnson & Johnson', '(1 unidad)', 1, 2.5, true),
    createData('013', 'Jabón', 'Protex', '(1 unidad)', 1, 2, true),
    createData('014', 'Whisky', 'Chivas Regal', '(0.75 litros)', 20, 28, true),
  ];


const Products = () => {

    const [ clients, setClients ] = useState([]);
    const [ paginations, setPaginations ] = useState(0);
    const [ initResult, setInitResult ] = useState(0);
    const [ endResult, setEndResult ] = useState(10);
    const searchData = useSelector( state => state.Search.data );

    const [page, setPage] = React.useState(1);
    const handleChange = (event, value) => {
        if( page < value ){
            // aumentar
            setInitResult(initResult+10);
            setEndResult(endResult+10);
        }else{
            // disminuir
            setInitResult(initResult-10);
            setEndResult(endResult-10);
        }
        setPage(value);
    };

    useEffect( () => {
        const textToSearch = searchData.toLowerCase();
        const mappingArray = rows.filter( (item, index) => {
            return ( index >= initResult && index < endResult ) ? item : null;
        } );

        if(searchData !== ''){
            const filteredElements = rows.filter( (item, index) => item.name.toLowerCase().includes(textToSearch) || 
                                                  item.brand.toLowerCase().includes(textToSearch) ||
                                                  item.details.toLowerCase().includes(textToSearch) );
            setClients(filteredElements);
        }else{
            const filteredElements = mappingArray.filter( (item, index) => item.name.toLowerCase().includes(textToSearch) || 
                                              item.brand.toLowerCase().includes(textToSearch) ||
                                              item.details.toLowerCase().includes(textToSearch) );
            setClients(filteredElements);
        }

        setPaginations(Math.ceil(rows.length/10))
    },[searchData, initResult, endResult] );

    const dispatch = useDispatch();
    const [ showModal, setShowModal ] = useState(false);
    const [ showDeleteModal, setShowDeleteModal ] = useState(false);
    const [ modalForm, setModalForm ] = useState('');
    const [ deleteModal, setDeleteModal ] = useState('');
    const modalStatus = useSelector( state => state.Modal.modalState );
    const deleteModalStatus = useSelector( state => state.Modal.deleteModalState );
    const [ productData, setProductData ] = useState({});

    useEffect( () => {
        setShowModal(modalStatus);
      }, [modalStatus] );
    
    useEffect( () => {
        setShowDeleteModal(deleteModalStatus);
      }, [deleteModalStatus] );

    const editClient = (data) => {
        setProductData(data);
        setDeleteModal('');
        dispatch(modalAction());
        setModalForm('editProduct');
    }

    const deleteClient = () => {
        setModalForm('');
        dispatch(modalDeleteAction());
        setDeleteModal('product');
    }

  return (
    <>
        {
            (showModal && modalForm !== '' ) &&
            <SuccessModal view={modalForm} product={productData} />
        }
        {
            (showDeleteModal && deleteModal !== '' ) &&
            <DangerModal view={deleteModal} />
        }
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Marca</TableCell>
                    <TableCell>Detalles</TableCell>
                    <TableCell>Precio de compra</TableCell>
                    <TableCell>Precio de venta</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align='center'>Acciones</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {clients.map((row) => (
                    <TableRow
                    key={row.code}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">{row.code}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.brand}</TableCell>
                    <TableCell>{row.details}</TableCell>
                    <TableCell>${row.buyPrice}</TableCell>
                    <TableCell>${row.sellPrice}</TableCell>
                    <TableCell>{
                        (row.status) ? 'Activado' : 'Desactivado'
                    }</TableCell>
                    <TableCell align='center'>{
                        <>
                            <PrimaryIconButton aria-label="delete" sx={{ mx: '.4rem' }} onClick={ () => editClient(row) }>
                                <EditIcon />
                            </PrimaryIconButton>
                            <SecondaryIconButton aria-label="delete" onClick={ () => deleteClient() }>
                                <DeleteIcon />
                            </SecondaryIconButton>
                        </>
                    }</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>

        <Grid container sx={{ justifyContent: 'end', textAlign: 'end', mt: 2 }}>
            <PaginationGrid item xs={12}>
                <Pagination
                    count={paginations}
                    onChange={handleChange}
                    renderItem={(item) => (
                        <PaginationItemStyled
                        components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                        />
                    )}
                />
            </PaginationGrid>
        </Grid>
    </>
  )
}

export default Products